<script setup lang="ts">
import Feedback from "~/components/Feedback/Feedback.vue";
import { useFeedback } from "~/composables/feedback/useFeedback";

const feedbacks = useFeedback();
</script>

<template>
  <div class="feedback_container">
    <TransitionGroup name="fade" tag="ul">
      <li
        v-for="feed in feedbacks.feedbacks.value"
        :key="`key-${feed.uuid}`"
        @click="feedbacks.remove(feed.uuid as string)"
      >
        <Feedback :feedback="feed" />
      </li>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.feedback_container {
  @apply fixed flex justify-center items-center top-4 w-full;
  z-index: 501;
}
</style>
